import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2002')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('drawing') || media.includes('painting');
  })
  .slice(0, 4);

export default function MariaPark() {
  const slides = [
    { src: '/uploads/Maria-park-2000_1280x783.jpg', alt: 'Maria Park work 1' },
    { src: '/uploads/mariapark1.jpg', alt: 'Maria Park work 2' },
    { src: '/uploads/mariapark2.jpg', alt: 'Maria Park work 3' },
    { src: '/uploads/mariapark3.jpg', alt: 'Maria Park work 4' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Maria Park</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Maria Park slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2002</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>We selected Maria Y. Park as the winner of the 2002 KAFA Award because we feel that her work combines a high level of ambition and accomplishment in a manner that is original and promising. Using a variety of media and techniques, including acrylic on canvas, collage on paper, and multi-colored tape applied directly to the wall, the young San Francisco-based artist (who was born in Germany) creates fantastic landscapes that are equally indebted to comic books, computer graphics, and contemporary painting. Simultaneous playful and cool, Park’s crisply rendered images of futuristic spacemen, ancient Chinese warriors, and pack of penguins (among many otherwise unrelated elements) are suffused with a slyly ominous streak that bespeaks a deep suspicion about the giddy pleasures provided by the Internet, often at whiplash speeds. As a group, her diverse, multi-scaled works give energetically animated form to the polyglot, sometimes chaotic feel of modern life, in which a seemingly endless glut of images competes for our attention. With a savvy, light-handed touch, Park brings Surrealism up to date, where its strange, psychological twists are dispersed across un-private territory of cyberspace.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Howard N. Fox, Curator of Modern and Contemporary Art, Los Angeles County Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Henry Hopkins, Professor of Art, University of California, Los Angeles</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>David Pagel, Art Critic, Los Angeles Times, writer and curator</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Maria Park is an Associate Professor and Director of AAP Exhibitions and Events in the College of Art, Architecture, and Planning at Cornell University. Ranging from serially based paintings to site-specific installations combining studio- produced and manufactured objects, her work explores human presence and agency within a media-reliant society. Since graduating with an MFA in Painting from the San Francisco Art Institute in 2003, Park’s works have been included in numerous exhibitions both nationally and internationally. Museum projects include solo exhibitions at The Kemper Museum of Contemporary Art in Kansas City, MO and the Museum of Contemporary Art in Santa Rosa, CA, and group exhibitions at the Johnson Museum of Art in Ithaca, NY, Contemporary Art Museum in St. Louis, MO, and the Seoul National Museum of Art in Seoul, South Korea. Park was commissioned a permanent installation for the new building at Johns Hopkins Hospital in Baltimore, MD (2012) and has recently completed the design of a 150-foot mural, Sight Plan, for the central subway temporary barricade at the Chinatown Station in San Francisco, CA, commissioned through the San Francisco Arts Commission in partnership with San Francisco Municipal Transportation Agency. Park’s collaborative project, Oculi, with Austin + Mergold and consulting engineers Chris Earls and Scott Hughes won the 2018 City of Dreams Pavilion Competition and will be installed on Governors Island, NYC, in the summer of 2018.  Awards include the MFA Grant Award from the Joan Mitchell Foundation (2003) and the Korea Arts Foundation of America Award (2002), and the Murphy Fine Arts Fellowship from the San Francisco Foundation.  She is represented by Margaret Thatcher Projects in New York City and Nancy Toomey Fine Art in San Francisco, CA.</p>

            <a href='https://mariapark.net/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
